export const Days = {
    'SUN': "Domingo",
    'MON': "Segunda-Feira",
    'TUE': "Terça-Feira",
    'WED': "Quarta-Feira",
    'THU': "Quinta-Feira",
    'FRI': "Sexta-Feira",
    'SAT': "Sábado"
};

export const MonthWeeks = {
    '#1': "Primeiro",
    '#2': "Segundo",
    '#3': "Terceiro",
    '#4': "Quarto",
    '#5': "Quinto",
    'L': "Útilmo"
};

export enum Months {
    Janeiro = 1,
    Fevereiro,
    Março,
    Abril,
    Maio,
    Junho,
    Julho,
    Agosto,
    Setembro,
    Outubro,
    Novembro,
    Dezembro
};